type AuthChangeCallback = (firebaseUser: { uid: string } | null) => void;
type AuthModule = { onAuthChange: (callback: AuthChangeCallback) => () => void };

export function subscribeToAuthChanges(
  loadAuthModule: () => Promise<AuthModule>,
  callback: AuthChangeCallback,
): () => void {
  let cancelled = false;
  let unsubscribe: (() => void) | undefined;

  loadAuthModule().then((authModule) => {
    if (cancelled) return;
    unsubscribe = authModule.onAuthChange(callback);
  }).catch(() => {
    if (!cancelled) return;
  });

  return () => {
    cancelled = true;
    unsubscribe?.();
  };
}
